var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 24.479C7.8335 22.8567 9.14866 21.5415 10.771 21.5415H36.2293C37.8517 21.5415 39.1668 22.8567 39.1668 24.479V25.4582V25.4582C39.1668 33.0291 33.0294 39.1665 25.4585 39.1665H21.5418C13.9709 39.1665 7.8335 33.0291 7.8335 25.4582V25.4582V24.479Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9276 7.8335C15.5473 8.68654 15.8139 9.74583 15.6718 10.7906C15.3585 12.3377 13.8897 12.7489 13.7135 14.2177C13.685 14.7667 13.7792 15.3153 13.9892 15.8234C14.1992 16.3315 14.5198 16.7865 14.9276 17.1552",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.701 7.83362C25.0173 8.24781 25.2478 8.72097 25.379 9.22538C25.5101 9.72979 25.5393 10.2553 25.4647 10.7711C25.1514 12.3378 23.6827 12.7295 23.5064 14.2178C23.4741 14.7655 23.5645 15.3135 23.7712 15.8217C23.9779 16.33 24.2956 16.7856 24.701 17.1553",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4941 7.83362C34.813 8.25024 35.0449 8.72668 35.1761 9.23465C35.3073 9.74262 35.3351 10.2718 35.2579 10.7907C34.9446 12.3378 33.4758 12.749 33.2996 14.2178C33.2639 14.7677 33.3548 15.3184 33.5652 15.8276C33.7757 16.3369 34.1002 16.7911 34.5137 17.1553",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.5d3529a8df68a19ee7d7a7217e966ff9.svg";
export { ForwardRef as ReactComponent };